export { default as TabContainer } from './TabContainer';
